import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Row, Col, Spinner } from "react-bootstrap";

import Card from "../../components/Card";
import MasterService from "../../services/master/MasterService";
import DataTable from "react-data-table-component";

const JenisUji = () => {
    const columns = [
        {
            name: 'ID',
            cell: row => row['idJenisUji'] 
        },
        {
            name: 'Keterangan Jenis Uji',
            cell: row => row['ketJenisUji'] 
        }
    ]

    let masterService = useMemo(() => new MasterService(), [])

    const [listJenisUji, setlistJenisUji] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getlistJenisUji = useCallback(async (page, size) => {
        setLoading(true)
        try {
            const response = await masterService.listJenisUji(null, page, size)
            setlistJenisUji(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            console.log(error)
            setlistJenisUji([])
        }
        setLoading(false)
    }, [masterService])

    useEffect(() => {
        getlistJenisUji(0, 10)
    }, [getlistJenisUji])

    const handleChangePage = (page) => {
        getlistJenisUji(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        const _res = await masterService.listJenisUji(null, page - 1, size)
        setlistJenisUji(_res.data.data)
        setSize(size)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar Master Jenis Pengujian</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                        <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listJenisUji}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );

}

export default JenisUji